"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toXOnly = exports.getOrdinalScript = exports.splitBuffer = exports.createAddressObjectByScriptNoType = void 0;
const bitcoin = __importStar(require("bitcoinjs-lib"));
const secp256k1_1 = __importDefault(require("@bitcoinerlab/secp256k1"));
bitcoin.initEccLib(secp256k1_1.default);
function createAddressObjectByScriptNoType(script, network = bitcoin.networks.bitcoin) {
    let addressObject;
    try {
        addressObject = bitcoin.payments.p2pkh({
            output: script,
            network,
        });
        if (addressObject.address) {
            return {
                addressObject,
                addressType: "p2pkh",
            };
        }
    }
    catch (err) {
    }
    try {
        addressObject = bitcoin.payments.p2wpkh({
            output: script,
            network,
        });
        if (addressObject.address) {
            return {
                addressObject,
                addressType: "p2wpkh",
            };
        }
    }
    catch (err) {
    }
    try {
        addressObject = bitcoin.payments.p2sh({
            output: script,
            network,
        });
        if (addressObject.address) {
            return {
                addressObject,
                addressType: "p2sh",
            };
        }
    }
    catch (err) {
    }
    try {
        addressObject = bitcoin.payments.p2wsh({
            output: script,
            network,
        });
        if (addressObject.address) {
            return {
                addressObject,
                addressType: "p2wsh",
            };
        }
    }
    catch (err) {
    }
    try {
        addressObject = bitcoin.payments.p2tr({
            output: script,
            network,
        });
        if (addressObject.address) {
            return {
                addressObject,
                addressType: "p2tr",
            };
        }
    }
    catch (err) {
    }
}
exports.createAddressObjectByScriptNoType = createAddressObjectByScriptNoType;
function splitBuffer(buffer, partLength) {
    const parts = [];
    for (let i = 0; i < buffer.length; i += partLength) {
        const part = buffer.subarray(i, i + partLength);
        parts.push(part);
    }
    return parts;
}
exports.splitBuffer = splitBuffer;
function getOrdinalScript(file, internalPublicKeyHex) {
    let bufferParts = splitBuffer(file.buffer, 520);
    const splittedFileHex = bufferParts.map((part) => part.toString("hex")).join(" ");
    const fileTypeHex = Buffer.from(file.type, "utf8").toString("hex");
    const ORDINAL_ORD_HEX = Buffer.from("ord", "utf8").toString("hex");
    const script = `${internalPublicKeyHex} OP_CHECKSIG OP_FALSE OP_IF ${ORDINAL_ORD_HEX} 00000000000000000000 ${fileTypeHex} OP_0 ${splittedFileHex} OP_ENDIF`;
    const leafScript = Buffer.from(bitcoin.script.fromASM(script).toString("hex").replace("0a00000000000000000000", "0101"), "hex");
    return leafScript;
}
exports.getOrdinalScript = getOrdinalScript;
function toXOnly(pubKey) {
    return pubKey.length === 32 ? pubKey : pubKey.subarray(1, 33);
}
exports.toXOnly = toXOnly;
//# sourceMappingURL=ordinal-helper.js.map